import { useNavigate } from "react-router-dom";
import ProfileForm from "../components/ProfileForm";
import { useProfile } from "../hooks/queries/useMe";
import { BankName } from "../constants/banks";
import { useUpdateProfile } from "../hooks/mutations/useUpdateProfile";
import toast from "react-hot-toast";
import Header from "../components/Header";

const ProfilePage = () => {
  const navigate = useNavigate();
  const {data: user, isLoading} = useProfile();
  const {mutate: updateProfile, isPending} = useUpdateProfile();

  const handleUpdateProfile = (data: { name?: string; bank?: string; account_number?: string }) => {
    updateProfile(data, {
      onSuccess: () => {
        toast.success('내 정보 수정 완료!');
        navigate(-1);
      }
    });
  };

  return (
    <div className="container mx-auto px-4 w-full pt-20 flex flex-col items-center">
      <Header title="내 정보 수정" showBackButton={true} onBackClick={() => navigate(-1)} />
      {
        user ? (
        <ProfileForm
          isLoading={isLoading || isPending}
          updateUserProfile={handleUpdateProfile}
          defaultValues={{
            fullName: user.name,
            bank: user.bank as BankName,
            accountNumber: user.account_number,
          }}
          isEdit={true}
        />
      ):(
        <div className="w-8 h-8 mt-8 border-4 border-gray-800 border-t-transparent rounded-full animate-spin"></div>
      )}
    </div>
  )
}

export default ProfilePage;